<template>
    <div class="ma-4">
        <ClientNav/>
        <v-row dense>
            <v-col cols="12">
                <v-card>
                    <v-card-title style="background-color: #2b3990">
                        <span class="headline white--text">{{ titleForm }}</span>
                    </v-card-title>
                <v-card-text>
                    <v-form ref="form" lazy-validation>
                        <v-container>
                            <ect @clicked="selectedCode"/>

                            <v-row>
                                <v-col cols="12" sm="12" md="6">
                                    <v-menu
                                        ref="menu"
                                        v-model="menu"
                                        :close-on-content-click="false"
                                        :return-value.sync="date"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="auto"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                v-model="newStartDate"
                                                label="Start Date"
                                                prepend-icon="mdi-calendar"
                                                readonly
                                                v-bind="attrs"
                                                v-on="on"
                                                clearable
                                                class="full-width"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                            v-model="newStartDate"
                                            no-title
                                            scrollable
                                        >
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                text
                                                color="primary"
                                                @click="menu = false"
                                            >
                                                Cancel
                                            </v-btn>
                                            <v-btn
                                                text
                                                color="primary"
                                                @click="$refs.menu.save(date)"
                                            >
                                                OK
                                            </v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col class="d-flex" cols="12" sm="12" md="6">
                                    <v-menu
                                        ref="menu2"
                                        v-model="menu2"
                                        :close-on-content-click="false"
                                        :return-value.sync="date"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="auto"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                v-model="newEndDate"
                                                label="End Date"
                                                prepend-icon="mdi-calendar"
                                                readonly
                                                v-bind="attrs"
                                                v-on="on"
                                                clearable
                                                class="full-width"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                            v-model="newEndDate"
                                            no-title
                                            scrollable
                                            :min="minEndDate"
                                        >
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                text
                                                color="primary"
                                                @click="menu2 = false"
                                            >
                                                Cancel
                                            </v-btn>
                                            <v-btn
                                                text
                                                color="primary"
                                                @click="$refs.menu2.save(date)"
                                            >
                                                OK
                                            </v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col cols="12" sm="12">
                                    <v-text-field
                                        label="Diagnosis"
                                        v-model="diagnosis"
                                        class="full-width"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="4">
                                    <v-select
                                        label="Diagnosis Type"
                                        v-model="newType"
                                        :items="diagType"
                                        class="full-width"
                                    ></v-select>
                                </v-col>
                                <v-col cols="12" sm="12" md="4">
                                    <v-text-field
                                        v-model="newICDCode"
                                        label="ICD-10 Full Code"
                                        class="full-width"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="4">
                                    <v-text-field
                                        label="Diagnosed By"
                                        v-model="newDiagnosedBy"
                                        class="full-width"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        fab
                        small
                        @click="showPrintModal()"
                        class="mr-8 mb-2 white--text"
                        color="#2b6993"
                        elevation="4"
                        v-if="!newDiagnosis"
                    >
                        <v-icon>print</v-icon>
                    </v-btn>
                    <v-btn
                        class="white--text"
                        color="#259647"
                        @click="addDiag()"
                        v-if="newDiagnosis"
                    >Save
                    </v-btn
                    >
                    <v-btn
                        color="blue darken-1 white--text"
                        @click="updateDiag()"
                        v-if="!newDiagnosis"
                    >Update
                    </v-btn
                    >
                    <v-btn color="blue darken-1" text @click="close"
                    >Cancel
                    </v-btn
                    >
                </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <Foot/>
    </div>
</template>

<script>
import axios from "axios";
import ClientNav from "../../../components/ClientNav";
import Foot from "../../../components/Footer";
import moment from "moment";
import ect from "../../../components/Ect";
import {displaySuccess, displayError} from "@/service/notification-message.service";
import PrintUtil from "../../../../utils/print-util";

const url = require("../../../client_config/config").url;

export default {
    components: {
        ClientNav,
        Foot,
        ect,
    },
    data() {
        return {
            date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                .toISOString()
                .substr(0, 10),
            menu: false,
            menu2: false,
            newDiagnosis: false,
            msg: false,
            search: "",
            text: "",
            diagnose: {},
            tempData: [],
            clientID: this.$route.params.clientID,
            diagnosisId: this.$route.params.id,
            token: localStorage.getItem('token'),
            titleForm: "New Diagnoses",
            diagID: "",
            diagnosis: "",
            newStartDate: "",
            newICDCode: "",
            newType: "",
            newDiagnosedBy: "",
            newEndDate: "",
            requiredField: [(v) => !!v || "This is required"],
            item: "",
            diagType: ["Medical", "Clinical"],
            editedIndex: -1,
            editedItem: {
                Diagnosis: "",
                startDate: "",
                type: "",
                icdCode: "",
                diagnosedBy: "",
                endDate: "",
            },
            defaultItem: {
                Diagnosis: "",
                startDate: "",
                type: "",
                icdCode: "",
                diagnosedBy: "",
                endDate: "",
            },
            isLoading: true,
        };
    },

    computed: {
        minEndDate() {
            return this.newStartDate ? this.newStartDate : null;
        },
    },

    watch: {},

    created() {
        this.newDiagnosis = this.$route.query.newDiagnosis === 'true'
        this.getDiagnoses();
    },

    mounted() {
        if (!this.newDiagnosis) {
            this.getDiagnose();
        }

        window.addEventListener('keydown', async (event) => {
            this.downloadUrl = await this.generateDownloadUrl();
            PrintUtil.handleKeydown(event, this.downloadUrl, this.diagnosisId, this.token, 'DiagnosisForm');
        });
    },

    beforeDestroy() {
        window.removeEventListener('keydown', (event) => {
            PrintUtil.handleKeydown(event, this.downloadUrl, this.diagnosisId, this.token, 'DiagnosisForm');
        });
    },

    methods: {

        initialize() {
            this.diagnoses = [];
        },

        validate() {
            return this.$refs.form.validate();
        },

        viewDiag(item) {

            this.titleForm = "Viewing " + item.Diagnosis;
            this.diagnosis = item.Diagnosis;
            this.newStartDate = item.StartDate;
            this.newICDCode = item.ICDCode;
            this.newType = item.DiagnosisType;
            this.newDiagnosedBy = item.DiagnosedBy;
            this.newEndDate = item.EndDate;
            this.diagnosisId = item._id;
        },


        close() {
            this.clear();
            this.$router.go(-1);
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },

        async updateDiag() {
            let req_body = {
                StartDate: this.newStartDate,
                Diagnosis: this.diagnosis,
                DiagnosisType: this.newType,
                ICDCode: this.newICDCode,
                DiagnosedBy: this.newDiagnosedBy,
                EndDate: this.newEndDate,
            };

            try {
                const response = await axios.put(`${url}/diagnoses/${this.diagnosisId}`, req_body)
                if (response.status !== 200) {
                    displayError("An error occurred while updating the diagnosis");
                }
                displaySuccess("The diagnosis has been updated successfully");
            } catch (error) {
                console.log(error);
            } finally {
                this.close();
            }
        },

        getDiagnoses() {
            this.isLoading = true;
            this.diagnoses = [];
            axios
                .get(`${url}/diagnoses/client/${this.clientID}`)
                .then((res) => {
                    this.diagnoses = res.data.diagnoses;
                })
                .finally(() => (this.isLoading = false));
        },

        getDiagnose() {
            this.isLoading = true;
            this.diagnoses = [];
            axios
                .get(`${url}/diagnoses/${this.diagnosisId}`)
                .then((res) => {
                    this.diagnose = res.data.diag;
                    this.viewDiag(this.diagnose);
                })
                .finally(() => (this.isLoading = false));
        },

        async addDiag() {
            if (this.validate()) {
                let req_body = {
                    StartDate: this.newStartDate,
                    Diagnosis: this.diagnosis,
                    DiagnosisType: this.newType,
                    ICDCode: this.newICDCode,
                    DiagnosedBy: this.newDiagnosedBy,
                    EndDate: this.newEndDate,
                    ClientID: this.clientID,
                };

                try {
                    const response = await axios.post(`${url}/diagnoses`, req_body);
                    if (response.status !== 200) {
                        displayError("An error occurred while adding the diagnosis");
                    }
                    displaySuccess("The diagnosis has been added successfully");
                    this.getDiagnoses();
                } catch (error) {
                    console.log(error);
                } finally {
                    this.close();
                }
            } else {
                displayError("Please fill in all required fields");
            }
        },

        clear() {
            this.newStartDate = moment(new Date()).format("YYYY-MM-DD");
            this.newEndDate = "";
            this.diagnosis = "";
            this.newType = "";
            this.newICDCode = "";
            this.newDiagnosedBy = "";
        },

        selectedCode(item) {
            this.newICDCode = item;
        },

        async generateDownloadUrl() {
            return `${url}/diagnoses/print?id=${this.diagnosisId}`;
        },

        async showPrintModal() {
            this.downloadUrl = await this.generateDownloadUrl();
            PrintUtil.showPrintOption(this.downloadUrl, this.diagnosisId, this.token,'DiagnosisForm');
        },
    },
};
</script>
<style>
@media only screen and (min-width: 768px) {
    .mobile {
        display: none;
    }
}

@media only screen and (max-width: 600px) {
    .desktop {
        display: none;
    }
}
.full-width {
    width: 100% !important;
}
</style>
